import React from 'react';
import { useTranslation } from 'react-i18next';

import Card from '../../gcompts/Card';
import Footer from '../../components/Footer/Footer';
import ContactPage from '../../pages/Contact/ContactPage';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import HorizontalCarousel from '../../components/HorizontalCarousel/HorizontalCarousel';

import './MeetingsGatherings.css';
import MGPanels from './panels/MGPanels';


const MeetingsGatherings: React.FC = () => {

  const { t } = useTranslation();

  const data = [
    {
      property: 'atacama',
      title: t('properties/atacama:meetingsEvents.events.0.title' as any),
      description: t('properties/atacama:meetingsEvents.events.0.description' as any),
      image: '/assets/images/meetings-events/2021 - 11 - 01 - Andreia & Tiago - (44).jpg'
    },
    {
      property: 'atacama',
      title: t('properties/atacama:meetingsEvents.events.1.title' as any),
      description: t('properties/atacama:meetingsEvents.events.1.description' as any),
      image: '/assets/images/meetings-events/AWASI - MENDOZA-4.jpg'
    },
    {
      property: 'atacama',
      title: t('properties/atacama:meetingsEvents.events.2.title' as any),
      description: t('properties/atacama:meetingsEvents.events.2.description' as any),
      image: '/assets/images/meetings-events/LD3A6718.jpg'
    },
    {
      property: 'atacama',
      title: t('properties/atacama:meetingsEvents.events.3.title' as any),
      description: t('properties/atacama:meetingsEvents.events.3.description' as any),
      image: '/assets/images/meetings-events/fotos--66.jpg'
    },
    {
      property: 'atacama',
      title: t('properties/atacama:meetingsEvents.events.4.title' as any),
      description: t('properties/atacama:meetingsEvents.events.4.description' as any),
      image: '/assets/images/meetings-events/ADC05350.jpg'
    },
  ]

  const goToContact = () => {
    const element = document.getElementById('contact-page');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const contentByProperties = (properties: string[]) => {
    return data.filter(item => properties.includes(item.property));
  };

  return (
    <div >
      {/* Navigation - Atacama variant */}
      <UnifiedNavigation variant="dark" />

      {/* Hero Section with Diptych - Full Screen 50/50 */}
      <section className="meetings-hero-diptych" data-scroll-section>
        <div className="meetings-hero-text-block">
          <p className="meetings-hero-description">
            {t('properties/atacama:meetingsEvents.hero.description' as any)}
          </p>
        </div>
        <div
          className="meetings-hero-image-block"
          style={{ backgroundImage: `url('/assets/images/meetings-events/A7408400.jpg')` }}
        />
      </section>

      {/* Event Spaces Gallery with Filters */}
      <section className="meetings-occasions-section" data-scroll-section>
        <div className="meetings-occasions-content">
          {/* Filter Section - Matching Figma exactly */}
          {/* <div className="meetings-filter-buttons">
            <button className="meetings-filter-btn">
              AWASI ATACAMA +
            </button>
            <button className="meetings-filter-btn">
              TYPE +
            </button>
          </div> */}

          <div className="meetings-occasions-gallery-content">
            <div className="meetings-occasions-gallery">
              {contentByProperties(['atacama']).map((item, index) => (
                <Card
                  key={`mg-card-${index}-${item.title}`}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                  goToContact={goToContact}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <HorizontalCarousel>
        <MGPanels />
      </HorizontalCarousel>

      <ContactPage full={false} />
      <InstagramSection />
      <Footer variant="default" />
    </div>
  );
};

export default MeetingsGatherings;